var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"font-size-12 grey--text w-100 mb-0",class:{
    'text--darken-2': !_vm.disabled,
    'red--text': _vm.error,
  },attrs:{"data-testid":_vm.tid}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }